import { height, width } from '../settings/mapSize.json';

export const getDotPosition = ([x, y]) => ({
    top: `${(y / height) * 100}%`,
    left: `${(x / width) * 100}%`,
});
